import Navbar from "@/components/Navbar";
import BookAppointment from "@/components/BookAppointment";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BookingPage = () => {
  const [searchParams] = useSearchParams();
  const fromPayment = searchParams.get("from") === "payment";

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="container mx-auto px-4 pt-24 pb-16 max-w-2xl">
        {!fromPayment && (
          <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6">
            <ArrowLeft size={16} /> Back to dashboard
          </Link>
        )}
        <BookAppointment />
      </div>
    </div>
  );
};

export default BookingPage;
